// middleware/auth.js
export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore()

  if (!authStore.isLogged) {
    await authStore.getTwitterProfile()
  }
})
